module.exports = new Promise(resolve => {
            const script = document.createElement('script');
            script.src = window.location.origin + '/mfe/care-gaps/remoteEntry.js';
            script.onload = () => { resolve(window['careGaps']); };
            script.onerror = () => { resolve({ get: () => Promise.resolve(() => () => 'Module careGaps unavailable'), init: () => {} }); };
            document.head.appendChild(script);
        });